module.exports = __webpack_public_path__ + "static/list-title-bg1@2x-e4a156801ec237c712e4db60b8093c2a.png";